import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const isSquare = css``;
export const blur = css``;

export const bg = css`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  &.${blur} {
    filter: blur(4px);
    transform: scale(1.1);
  }
`;

export const withoutOverlay = css``;

export const root = css`
  color: white;
  position: relative;
  background-color: black;
  overflow: hidden;
  aspect-ratio: 9/14;
  padding: 1em;
  display: grid;
  max-height: 100%;
  container: feed / inline-size;
  grid-template-rows: min-content 1fr min-content;
  grid-template-areas:
    'header'
    'player'
    'footer';

  &:not(.${withoutOverlay})::before {
    position: absolute;
    content: ' ';
    top: 0;
    left: 0;
    right: 0;
    bottom: auto;
    height: 50%;
    z-index: 10;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
  }
  &:not(.${withoutOverlay})::after {
    position: absolute;
    z-index: 10;
    content: ' ';
    bottom: 0;
    left: 0;
    right: 0;
    top: auto;
    height: 15%;
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
  }
  & * {
    @container feed (min-width: 300px) {
      --btn-icon-size: 50px;
    }
  }
`;

export const album = css`
  grid-area: player;
  position: absolute;
  pointer-events: none;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  aspect-ratio: 1;
  min-height: 0;
  img {
    min-height: 0;
    aspect-ratio: 1;
    border: 1px solid ${theme.colors.peoople['gris-medio']};
    min-width: 40%;
    border-radius: 4px;
    object-fit: cover;
  }
`;
